import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main'
import checkResponse from '@/utils/checkResponse'
import axios from 'axios'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  amount: payload.amount,
  invoice_number: payload.invoice_number,
  invoice_date: payload.invoice_date,
  supplier_id: payload.supplier_id,
  currency_id: payload.currency_id,
  tax_type: payload.tax_type
})
var crud = new Crud('SupplierInvoices', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  supplierInvoices: [],
  supplierInvoice: {},
  suppliers: {}
}

const mutations = {
  ...crud.mutations,
  UPDATE_RECORD (state, payload) {
    const idx = state.supplierInvoices.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.supplierInvoices, idx, payload)
    }
  },
  SET_INVOICE (state, payload) {
    state.supplierInvoice = payload
  },
  SET_SUPPLIERS (state, payload) {
    state.suppliers = payload
  }
}

const actions = {
  ...crud.actions,
  async addInvoice ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.post(`supplier-invoices`, payload)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.' + 'invoice', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
        commit('ADD_RECORD', response.data.invoice)
        commit('Suppliers/UPDATE_RECORD', response.data.supplier, { root: true })
        commit('SET_MODAL_VISIBLE', false)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadSuppliers ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get('invoices/suppliers')
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SUPPLIERS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  setInvoice ({ commit }, payload) {
    commit('SET_INVOICE', payload)
  },
  setModalSupplierPaymentsVisible ({ commit }, payload) {
    commit('SupplierPayments/SET_MODAL_VISIBLE', payload, { root: true })
  }
}

const getters = {
  ...crud.getters,
  supplierInvoices: state => state.supplierInvoices,
  supplierInvoice: state => state.supplierInvoice,
  suppliers: state => state.suppliers
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
